// 依赖assets/lib/webuploader
// site.css中重新了.webuploader-container样式
import * as WebUploader from 'webuploader';
import * as _ from 'lodash';

import { IUploaderErrorResponse, IUploaderParams } from 'src/models';
import { UPLOAD_FILE_EXTS_BLACK_LIST } from 'src/consts';
import toasterService from './toaster.service';

export default {
    toasterItemId: null, // toaster项的id
    uploaders: {},
    responses: [], // 记录每个文件上传的uploadSuccess结果，在uploadFinished时返回

    // 显示（应在组件的attached生命周期调用）
    show(params: IUploaderParams) {
        if (this.uploaders[params.selector]) {
            this.uploaders[params.selector].destroy();
        }

        const uploader = WebUploader.create({
            auto: params.auto === false ? false : true, // 若无auto参数，选择文件后默认自动上传
            server: params.server,
            formData: params.formData,
            pick: {
                id: params.selector,
                multiple: params.isMultiple, // 多选
            },
            dnd: params.dnd,
            disableGlobalDnd: true,
            accept: params.accept,
            threads: 1, // 单线程（每次只上传1个文件）
            fileSingleSizeLimit: params.sizeLimit,
            compress: false, // 不压缩
        });

        // 当有文件被添加进队列的时候
        uploader.on('fileQueued', (file: any) => {
            if (params.queuedCallback) {
                params.queuedCallback(file);
            }
        });

        // 文件被加入队列之前触发（禁止上传黑名单中的文件类型）
        uploader.on('beforeFileQueued', (file: any) => {
            const isInBlackList = _.includes(UPLOAD_FILE_EXTS_BLACK_LIST, _.lowerCase(file.ext));
            if (isInBlackList) {
                toasterService.show({
                    type: 'warning',
                    title: '提示',
                    contents: [
                        `基于安全考虑，系统不允许上传".js;.bat;.exe;.sh;.doc;.xls;.ppt"类型附件，附件"${file.name}"上传操作被取消`,
                    ],
                });
                return false; // 返回值为false，则此文件不会被添加进入队列
            }

            // 处理文件上传前的前置检查
            if (params.beforeUploadCallback) {
                if (!params.beforeUploadCallback(file)) {
                    return false;
                }
            }
            return true;
        });

        // 开始上传流程时触发
        uploader.on('startUpload', () => {
            if (params.startUploadDisabled) {
                // 不触发startUpload事件
                return;
            }
            this.toasterItemId = toasterService.show({
                type: 'info',
                title: `正在上传......`,
                timeout: 60000,
            });
        });

        // 上传过程中触发，携带上传进度
        uploader.on('uploadProgress', (file: any, percentage: number) => {
            if (params.progressCallback) {
                params.progressCallback(file, percentage);
            }
        });

        // 文件上传成功时触发
        uploader.on('uploadSuccess', (file: any, response: any) => {
            if (params.successCallback) {
                params.successCallback(response);
            }
            // 记录每个文件上传的uploadSuccess结果
            this.responses.push(response);
        });

        // 文件上传出错时触发
        // uploader.on('uploadError', (file: any, reason: string) => {
        //     console.log('reason', reason);
        //     if (params.errorCallback) {
        //         params.errorCallback(reason);
        //     }
        // });
        // (当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效。如果此事件handler返回值为false,则此文件将派送server类型的uploadError事件)
        uploader.on('uploadAccept', (object: any, response: IUploaderErrorResponse) => {
            // 项目、用户、部门批量导入时，不需调用errorCallback
            if (
                (_.includes(params.server, '/api/files/import-projects') &&
                    response.cannot_import === false) ||
                (_.includes(params.server, '/api/files/import-users') &&
                    response.cannot_import === false) ||
                (_.includes(params.server, '/api/files/import-orgs') &&
                    response.cannot_import === false)
            ) {
                return;
            }
            if (params.errorCallback && (response.message || response.errors?.length)) {
                params.errorCallback(response);
            }
        });

        // 文件上传完成时触发（不管成功或者失败）
        uploader.on('uploadComplete', (file: any) => {
            if (params.completeCallback) {
                params.completeCallback(file);
            }
        });

        // 所有文件上传结束时触发
        uploader.on('uploadFinished', () => {
            if (this.toasterItemId) {
                toasterService.remove(this.toasterItemId);
            }
            if (params.finishedCallback) {
                params.finishedCallback(_.cloneDeep(this.responses));
            }
            // 清空responses
            this.responses = [];
            uploader.reset();
        });

        this.uploaders[params.selector] = uploader;
    },

    // 更新server地址
    updateServerUrl(selector: string, serverUrl: string) {
        const uploader = this.uploaders[selector];
        if (!uploader) {
            return;
        }
        uploader.options.server = serverUrl;
    },

    // 开始上传
    upload(selector: string) {
        const uploader = this.uploaders[selector];
        if (!uploader) {
            return;
        }
        uploader.upload();
    },

    // 移除文件
    removeFile(selector: string, id: string) {
        const uploader = this.uploaders[selector];
        if (!uploader) {
            return;
        }
        const files = uploader.getFiles();
        if (!files.length) {
            return;
        }
        uploader.removeFile(id, true);
    },
};
